/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Secret_SetInputs */



/**
* | output |
* | --- |
* | "Set (hidden)" |
*
* @param {Spaces_Modular_Wizard_Secret_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_secret_set = /** @type {((inputs?: Spaces_Modular_Wizard_Secret_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Secret_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Festgelegt (verborgen)")
	return /** @type {LocalizedString} */ ("Set (hidden)")
});